export default __webpack_public_path__ + "static/media/release-icon.9864c551.png";